import { render, staticRenderFns } from "./HistorySuperTable.vue?vue&type=template&id=4073075b"
import script from "./HistorySuperTable.vue?vue&type=script&lang=js"
export * from "./HistorySuperTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports